/**
 * Determines the color of the border based on the status
 * @param {string} text Actionable status
 */

export const formatBorderClass = (text) => {
  let className = ''
  switch (text) {
    case 'U':
      className = 'new-capture'
      break
    case 'P':
      className = 'problem-capture'
      break
    case 'N':
      className = 'no-problem-capture'
      break
    case 'H':
      className = 'hold-capture'
      break
    case 'S':
      className = 'solved-capture'
      break
    // Only if there is a change
    case 'C':
      className = 'orangeBorder'
      break
    default:
      break
  }
  return className
}

/**
 * Determines the color required for status based on the capture status
 * @param {string} text Actionable status
 * @param {string} setting Differences between border or color depending on how the function needs to be used
 */
export const formatStatusClass = (text, setting) => {
  let className = ''
  switch (text) {
    case 'U':
      if (setting === 'border') {
        className = 'new-status-border'
      } else if (setting === 'color') {
        className = 'new-status-color'
      } else if (setting === 'text') {
        className = 'New'
      }
      break
    case 'P':
      if (setting === 'border') {
        className = 'problem-status-border'
      } else if (setting === 'color') {
        className = 'problem-status-color'
      } else if (setting === 'text') {
        className = 'Problem'
      }
      break
    case 'N':
      if (setting === 'border') {
        className = 'no-problem-status-border'
      } else if (setting === 'color') {
        className = 'no-problem-status-color'
      } else if (setting === 'text') {
        className = 'No Problem'
      }
      break
    case 'H':
      if (setting === 'border') {
        className = 'hold-status-border'
      } else if (setting === 'color') {
        className = 'hold-status-color'
      } else if (setting === 'text') {
        className = 'Hold'
      }
      break
    case 'S':
      if (setting === 'border') {
        className = 'solved-status-border'
      } else if (setting === 'color') {
        className = 'solved-status-color'
      } else if (setting === 'text') {
        className = 'Solved'
      }
      break
    // Only if there is a change
    case 'C':
      if (setting === 'border') {
        className = 'orangeStatusBorder'
      } else if (setting === 'color') {
        className = 'orangeStatusColor'
      } else if (setting === 'text') {
        className = 'Changed'
      }
      break
    default:
      break
  }
  return className
}

/**
 * Determines whether the source came from the keyboard or application
 * @param {number} source Source of violation
 */

export const getSourceDescription = (source) => {
  if (source === 0) {
    return 'Keyboard'
  } else if (source === 1) {
    return 'Application'
  } else {
    return source
  }
}

/**
 * Determines the severity of the violation according to the number range
 * @param {number} severity Severity of violation
 */
export const getSeverityClass = (severity) => {
  if (severity > 0 && severity <= 20) {
    return 'mild'
  } else if (severity > 20 && severity <= 40) {
    return 'okay'
  } else if (severity > 40 && severity <= 60) {
    return 'warn'
  } else if (severity > 60 && severity <= 80) {
    return 'notGreat'
  } else {
    return 'bad'
  }
}

export const getTotalPages = (count, limit) => {
  if (count) {
    return Math.ceil(count / limit)
  }
  return 0
}

/**
 * Returns the total number of violations
 * @param {number} count Number of counts
 */
export const getTotalViolations = (count) => {
  if (count) {
    return count
  }
  return 0
}

// outputs list of unitIDs given a Tree Data-formatted object. Optional argument to exclude parents units, defaults to false
export const keyify2 = (obj, childUnitsOnly = false) => {
  const dataArray = []
  if (!obj) { return dataArray }
  obj.forEach((item) => {
    if (!childUnitsOnly || !item.children.length) {
      dataArray.push(item.key)
    }
    if (item.children.length) {
      dataArray.push(...keyify2(item.children, childUnitsOnly))
    }
  })
  return dataArray
}

// outputs list of lowest-level unitIDs and names
export const parseUnitInfo = (obj, parent = null) => {
  const dataArray = []
  // const childArray = []
  if (!obj) { return dataArray }
  obj.forEach((item) => {
    // dataArray.push(item.key)
    if (item.children.length) {
      dataArray.push(...parseUnitInfo(item.children, parent ? `${parent} > ${item.title}` : item.title))
    } else {
      dataArray.push({ unitID: item.key, unitName: item.title, display: parent ? `${parent} > ${item.title}` : item.title })
    }
  })
  return dataArray
}
